module.exports = __webpack_public_path__ + "media/images/apple-0ba37f8fbd3d262613e7d4974f41715e.png";